import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle,
} from '@one-thd/sui-atomic-components';
import { Email, Delivery } from '@one-thd/sui-icons';
import { getNextGiftCardURL } from '../../hooks/useGiftCards';
import { navigate, isLocalHost } from '../../utils/util';
import { VERBIAGE } from '../../utils/consts';

const ListPod = (data) => {
  let listData = data?.item;
  const { productLineId, digital, physical } = listData;
  const showAtc = listData.digital || listData.physical;

  const btnClick = () => {
    const configurationId = digital?.configurationId || physical?.configurationId;
    let url = getNextGiftCardURL(listData.name, productLineId, configurationId);
    // if we have expversion in URL, then constructing & passing the same to PIP
    const params = new URLSearchParams(window.location.search);
    const preRelease = params.get('expversion');
    if (preRelease !== null) {
      const preReleaseUrl = `?debug=true&expversion=${preRelease}`;
      url += preReleaseUrl;
    }
    if (!isLocalHost()) {
      navigate(url, true);
    } else {
      console.log('Navigate to : ', url); // eslint-disable-line
    }
  };

  return (
    <Card CardContentProps={{ grow: true }}>
      <div className="sui-mx-auto">
        <CardMedia className="sui-rounded-md" src={listData.image} alt={listData.name} />
      </div>
      <div>
        <p className="sui-h4-display sui-flex sui-items-center sui-whitespace-pre-wrap">
          {listData.min !== listData.max && (
            <>
              <span className="sui-text-lg">$</span>
              <span data-testid="min-value">{listData.min}</span>
              <span> - </span>
            </>
          )}
          <span className="sui-text-lg">$</span>
          <span data-testid="max-value">{listData.max}</span>
        </p>
      </div>
      <CardTitle headerVariant="h5" header={listData.brandName} subheader={listData.name} />
      <CardBody>
        {digital && (
          <div className="sui-flex sui-items-center">
            <Email size="small" /> <span className="sui-ml-2">{VERBIAGE.digital}</span>
          </div>
        )}
        {physical && (
          <div className="sui-flex sui-items-center">
            <Delivery size="small" /> <span className="sui-ml-2">{VERBIAGE.Physical}</span>
          </div>
        )}
      </CardBody>
      <CardActions>
        <Button
          fullWidth
          variant="secondary"
          data-testid="choose-options"
          type="button"
          disabled={!showAtc}
          onClick={btnClick}
        >
          Choose Options
        </Button>
      </CardActions>
    </Card>
  );
};

export default ListPod;
